module.exports = __webpack_public_path__ + "static/media/Garoto.e9c2f971.png";